import * as React from "react";

import { Period, formatFullRange } from "../../periods";

interface CustomRangeFooterProps {
  isRangeComplete: boolean;
  focusPeriod: Period;
  comparisonPeriod: Period;
  // The buttons to apply or cancel
  children: React.ReactNode;
}

// What would be applied once a custom range's two days are picked, beside the buttons to apply it
export function CustomRangeFooter({
  isRangeComplete,
  focusPeriod,
  comparisonPeriod,
  children,
}: CustomRangeFooterProps) {
  return (
    <div className="tw:flex tw:flex-wrap tw:items-center tw:justify-between tw:gap-3 tw:border-t tw:border-neutral-200 tw:p-4">
      <p className="tw:m-0 tw:text-sm tw:text-neutral-500">
        {isRangeComplete ? (
          <>
            Focus{" "}
            <span className="tw:font-medium tw:text-neutral-950">
              {formatFullRange(focusPeriod)}
            </span>{" "}
            vs Comparison{" "}
            <span className="tw:font-medium tw:text-neutral-950">
              {formatFullRange(comparisonPeriod)}
            </span>
          </>
        ) : (
          "Pick both dates to apply."
        )}
      </p>
      {children}
    </div>
  );
}
